'use es6';

import { Fragment } from 'react';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { gate } from 'hub-http/gates';
import { debugGate } from '../utils/env';
import { jsx as _jsx } from "react/jsx-runtime";
const getPortal = state => state.auth.portal;
const getUser = state => state.auth.user;
const getGates = state => state.auth.gates;
const getIsUngated = createSelector([getGates], gates => name => gates.includes(name) || debugGate(name));
export const getIsCustomer = createSelector([getPortal], portal => !!(portal && portal.portal_id));

// TODO update if public fetches auth info
// TODO account for admin preview
export const getIsPublic = createSelector([getIsCustomer], isCustomer => !isCustomer);
export function PublicOnly({
  children
}) {
  const isPublicApp = useSelector(getIsPublic);
  return isPublicApp ? /*#__PURE__*/_jsx(Fragment, {
    children: children
  }) : null;
}
export const getUserFirstName = createSelector([getUser, getIsPublic], (user, isPublic) => isPublic ? null : user.first_name);
export const getUserLastName = createSelector([getUser, getIsPublic], (user, isPublic) => isPublic ? null : user.last_name);
export const getUserEmail = createSelector([getUser], user => user.email);
export const getUserId = createSelector([getUser], user => user.user_id);
const getUserScopes = createSelector([getUser], user => user.scopes);
const getHasScope = createSelector([getUserScopes], scopes => scope => scopes.includes(scope));
export const getHasZorseChatScope = createSelector([getHasScope], hasScope => hasScope('zorse-chat'));
export const getHasZorseWebticketScope = createSelector([getHasScope], hasScope => hasScope('zorse-webticket'));
export const getPortalScopes = createSelector([getPortal], portal => portal.scopes);
export const getIsUngatedForUnifiedDetails = createSelector([getIsUngated], isUngated => isUngated(gate('Marketplace:UnifiedDetails')));
export const getIsUngatedForUnifiedStorefront = createSelector([getIsUngated], isUngated => isUngated(gate('Marketplace:unified-storefront')));